module.exports = __webpack_public_path__ + "static/media/myImage.2fe759f2.png";